import { FormDataKey, FormDataState } from '../reducers/FormDataReducer'
import { StepID } from '../reducers/StepReducer'
import { UserRegistrationType } from '../reducers/UserRegistrationReducer'
// LANGUAGE ACTIONS
export const setLanguage = (payload: 'TH' | 'EN') => {
  return { type: 'SET_LANG', payload }
}

export const toggleLanguage = () => {
  return { type: 'TOGGLE_LANG' }
}

// LOCATION ACTIONS
export const setLocation = (payload: { lat: number; lng: number }) => {
  return { type: 'SET_LOCATION', payload }
}

// FORM DATA ACTIONS
export const setField = (payload: { field: FormDataKey; value: any }) => {
  return { type: 'SET_FIELD', payload }
}
export const setData = (payload: FormDataState) => {
  return { type: 'SET_DATA', payload }
}

// STEPS ACTIONS
export const setStepStatus = (payload: { id: StepID; value: boolean }) => {
  return { type: 'SET_STEP_STATUS', payload }
}

// USER ACTIONS

export const setUser = (payload: any) => {
  return { type: 'SET_USER', payload }
}

// SUBMISSION ACTIONS

export const setSubmission = (payload: FormDataState[]) => {
  return { type: 'SET_SUBMISSION', payload }
}

// USER REGISTRATION
interface SetUserPayloadType {
  field: keyof UserRegistrationType
  value: any
}
export const setUserField = (payload: SetUserPayloadType) => {
  return { type: 'SET_FIELD', payload }
}
